<template>
	<div class="business-platform-page">
		<section class="sec-10">
			<div class="container-box">
				<h2>
					{{ $t('new_ui.business_platform_page_v2.sec_10.title.one') }}
					<strong>
						{{ $t('new_ui.business_platform_page_v2.sec_10.title.two') }}
					</strong>
				</h2>
				<p>
					{{ $t('new_ui.business_platform_page_v2.sec_10.desc.one') }}<br />
					{{ $t('new_ui.business_platform_page_v2.sec_10.desc.two') }}
				</p>
				<div class="btn-box">
					<a href="/auth/register" class="btn-type-01">
						{{ $t('new_ui.business_platform_page_v2.sec_10.btn.one') }}
					</a>
					<a
						href="javascript:void(0)"
						@click="showComingSoon"
						class="btn-type-02"
					>
						{{ $t('new_ui.business_platform_page_v2.sec_10.btn.two') }}
					</a>
				</div>
				<div class="img-box">
					<img :src="img.imgBusinessPlatformSec10" alt="" />
				</div>
			</div>
		</section>
		<section class="sec-05">
			<div class="container-box">
				<h3>
					{{ $t('new_ui.business_platform_page_v2.sec_05.title.one') }}<br />
					{{ $t('new_ui.business_platform_page_v2.sec_05.title.two') }}
				</h3>
				<img :src="img.imgBusinessPlatformSec05" alt="" />
				<p>
					{{ $t('new_ui.business_platform_page_v2.sec_05.desc.one') }}
				</p>
			</div>
		</section>
		<section class="sec-11">
			<div class="container-box">
				<div class="content-box content-01">
					<h3>
						{{ $t('new_ui.business_platform_page_v2.sec_11.one.title.one') }}
					</h3>
					<p>
						{{ $t('new_ui.business_platform_page_v2.sec_11.one.desc.one') }}
					</p>
				</div>
				<div class="content-box content-02">
					<h3>
						{{ $t('new_ui.business_platform_page_v2.sec_11.two.title.one')
						}}<br />
						{{ $t('new_ui.business_platform_page_v2.sec_11.two.title.two') }}
					</h3>
					<p>
						{{ $t('new_ui.business_platform_page_v2.sec_11.two.desc.one')
						}}<br />
						{{ $t('new_ui.business_platform_page_v2.sec_11.two.desc.two') }}
					</p>
				</div>
			</div>
		</section>
	</div>
</template>

<script>
import imgBusinessPlatformSec10 from '@/assets/images/v2/img-business-platform-sec-10.png';
import imgBusinessPlatformSec05 from '@/assets/images/v2/img-business-platform-sec-05.png';

export default {
	data: () => {
		return {
			img: {
				imgBusinessPlatformSec10,
				imgBusinessPlatformSec05,
			},
		};
	},
	methods: {
		showComingSoon() {
			alert('Coming soon.');
		},
	},
};
</script>
